import * as React from 'react'
import CSecondaryNetworks from './CSecondaryNetworks';
import CTaux from './CTaux';
import CCustomAccess from './CCustomAccess';
import CMainProperties from './CMainProperties'
import CColumnsObj from './CColumnsObj';
import CQualifications from './CQualifications';
import CPerimResponsabilities from './CPerimResponsabilities';
import CBlocksPdv from './CBlocksPdv'
import CDisplayProperties from './CDisplayProperties'
import { Button, Col, Collapse, Row } from 'antd';
import { CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
const { Panel } = Collapse;
declare var $: any

export interface CollParameters {
    coll_id: string,
    name: string
}

export interface CollAccess {
    coll_id: string | undefined
    val_animation: boolean
    val_developpement: boolean
    val_developpement_modif: boolean
    val_animation_secondary_networks: ExistingNetworks | undefined
    val_developpement_secondary_networks: ExistingNetworks | undefined
    val_developpement_secondary_networks_modif: ExistingNetworks | undefined
}

export interface ExistingNetworks {
    network1: boolean
    network2: boolean
    network3: boolean
    network4: boolean
    network5: boolean
}

export interface MainProperties {
    file_iris_id: string,
    file_pdv_id: string,
    name: string,
    mainnetwork_name: string,
    link: string,
    unit: string,
    affichage: {
        nom_potentiel: string,
        nom_potentiel_accessible: string,
        nom_vente: string
    }
}

export interface SecondaryNetworks {
    secondaryNetworkNotEmpty: boolean[],
    secondary_networks: {
        secondarynetwork1_file_id: string,
        secondarynetwork1_name: string,
        secondarynetwork1_potentiel_combinable: boolean | null,
        secondarynetwork1_map_combinable: boolean | null,
        secondarynetwork2_file_id: string,
        secondarynetwork2_name: string,
        secondarynetwork2_potentiel_combinable: boolean | null,
        secondarynetwork2_map_combinable: boolean | null,
        secondarynetwork3_file_id: string,
        secondarynetwork3_name: string,
        secondarynetwork3_potentiel_combinable: boolean | null,
        secondarynetwork3_map_combinable: boolean | null,
        secondarynetwork4_file_id: string,
        secondarynetwork4_name: string,
        secondarynetwork4_potentiel_combinable: boolean | null,
        secondarynetwork4_map_combinable: boolean | null,
        secondarynetwork5_file_id: string,
        secondarynetwork5_name: string,
        secondarynetwork5_potentiel_combinable: boolean | null,
        secondarynetwork5_map_combinable: boolean | null,
    }
}

interface BlocPdvProperties {
    file_id: string,
    name: string,
    display_btn: boolean | null,
    display_gmap_url: boolean | null,
    excel_export: boolean | null,
    pdvs_unicolor: boolean | null,
    add_delete_authorized: boolean | null
}

export interface BlocsPdv {
    pdvBlocNotEmpty: boolean[],
    pdv_blocs: {
        bloc0: BlocPdvProperties,
        bloc1: BlocPdvProperties,
        bloc2: BlocPdvProperties,
        bloc3: BlocPdvProperties,
        bloc4: BlocPdvProperties
    }
}

export interface TauxProperties {
    affichage_taux: {
        affichage_taux_nom: string,
        affichage_taux_formatter_en_pourcent: boolean | null,
        affichage_taux_suffix: string
    }
}

export interface PerimResponsabilite {
    perim_responsabilite: {
        rang1: string,
        rang2: string,
        rang3: string,
        rang4: string,
        rang5: string,
    }
}

interface Products {
    prod1: boolean | undefined,
    prod2: boolean | undefined,
    prod3: boolean | undefined,
    prod4: boolean | undefined,
    prod5: boolean | undefined,
    prod6: boolean | undefined,
    prod7: boolean | undefined,
    prod8: boolean | undefined,
    prod9: boolean | undefined,
    prod10: boolean | undefined,
}

export interface DisplayProperties {
    affichage: {
        pot_total_tbc: boolean | undefined,
        affichage_pots_accessibles: boolean | undefined,
        affichage_pots_exploites: boolean | undefined,
        affichage_pistes: boolean | undefined,
        affichage_pistes_rg5_popup_map: boolean | undefined,
        affichage_gains_rg5_popup_map: boolean | undefined,
        affichage_pdm_rg5_popup_map: boolean | undefined,
        affichage_ventes_rg5_popup_map: boolean | undefined,
        affichage_gains: boolean | undefined,
        affichage_pdm: boolean | undefined,
        affichage_ventes: boolean | undefined,
        affichage_products: {
            pdm_product: Products,
            gain_product: Products,
            resume_left: Products,
            tbc_data: Products,
            showPotRg5: Products,
            showPotRg4: Products,
            showPotRg3: Products,
            showPotRg2: Products,
            showPotRg1: Products,
            showCaRg5: Products,
            showCaRg4: Products,
            showCaRg3: Products,
            showCaRg2: Products,
            showCaRg1: Products
        }
    }
}

interface GroupObjProperties {
    groupname: string,
    chp1: string,
    chp2: string,
    chp3: string,
    chp4: string,
    chp5: string,
    chp6: string,
    chp7: string,
    chp8: string,
    chp9: string,
    chp10: string
}

export interface GroupsObj {
    groupObjNotEmpty: boolean[],
    show_obj: boolean | null,
    obj_json: {
        groupobj1: GroupObjProperties,
        groupobj2: GroupObjProperties,
        groupobj3: GroupObjProperties,
        groupobj4: GroupObjProperties,
        groupobj5: GroupObjProperties,
    }

}

interface QualificationProperties {
    nom: string,
    legende: string,
    color: string
}

export interface Qualifications {
    qualificationNotEmpty: boolean[],
    qualification_json: {
        qualif1: QualificationProperties,
        qualif2: QualificationProperties,
        qualif3: QualificationProperties,
        qualif4: QualificationProperties,
    }
}

/* Customed components for the collapsed items */
const CustomHeader = ({ text, style }: { text: string, style: React.CSSProperties }) => {
    return (
        <div style={style}>{text}</div>
    );
};

const CustomArrowIcon = ({ isActive }: { isActive: boolean }) => {
    return isActive ?
        <CaretDownOutlined style={{ fontSize: '24px', marginRight: '10px' }} />
        :
        <CaretRightOutlined style={{ fontSize: '24px', marginRight: '10px' }} />;
};

export interface MainCSoftAccessProps {
    orgaId: string
    softaccessId: string
    isNew: boolean
    filesIris: Array<[string, string]>
    filesPdv: Array<[string, string]>
    myForm: Record<string, string>
    collaborators: CollParameters[]
    initialAccesses: CollAccess[] | null
    onCancel: () => void
    onSaved: () => void
}

export default function MainCSoftAccess({
    orgaId,
    softaccessId,
    isNew,
    filesIris,
    filesPdv,
    myForm: initialMyForm,
    collaborators,
    initialAccesses,
    onCancel,
    onSaved,
}: MainCSoftAccessProps) {

    const [myForm, setMyForm] = React.useState<any | undefined>(undefined)
    const [filesIrisState, setFilesIrisState] = React.useState<Array<[string, string]>>(filesIris)
    const [filesPdvState, setFilesPdvState] = React.useState<Array<[string, string]>>(filesPdv)
    const [collsValues, setCollsValues] = React.useState<CollParameters[]>(collaborators)
    const [collaboratorsAccesses, setCollaboratorsAccesses] = React.useState<CollAccess[]>([])
    const [existingNetworks, setExistingNetworks] = React.useState<ExistingNetworks>({
        network1: false,
        network2: false,
        network3: false,
        network4: false,
        network5: false
    })
    const [mainProperties, setMainProperties] = React.useState<MainProperties>({
        file_iris_id: '',
        file_pdv_id: '',
        name: '',
        mainnetwork_name: '',
        link: '',
        unit: '',
        affichage: {
            nom_potentiel: '',
            nom_potentiel_accessible: '',
            nom_vente: ''
        }
    })
    const [secondaryNetworks, setSecondaryNetworks] = React.useState<SecondaryNetworks>({
        secondaryNetworkNotEmpty: [false, false, false, false, false],
        secondary_networks: {
            secondarynetwork1_file_id: '',
            secondarynetwork1_name: '',
            secondarynetwork1_potentiel_combinable: true,
            secondarynetwork1_map_combinable: true,
            secondarynetwork2_file_id: '',
            secondarynetwork2_name: '',
            secondarynetwork2_potentiel_combinable: true,
            secondarynetwork2_map_combinable: true,
            secondarynetwork3_file_id: '',
            secondarynetwork3_name: '',
            secondarynetwork3_potentiel_combinable: true,
            secondarynetwork3_map_combinable: true,
            secondarynetwork4_file_id: '',
            secondarynetwork4_name: '',
            secondarynetwork4_potentiel_combinable: true,
            secondarynetwork4_map_combinable: true,
            secondarynetwork5_file_id: '',
            secondarynetwork5_name: '',
            secondarynetwork5_potentiel_combinable: true,
            secondarynetwork5_map_combinable: true,
        }
    })
    const initPdvBlocProperties: BlocPdvProperties = {
        file_id: '',
        name: '',
        display_btn: null,
        display_gmap_url: null,
        excel_export: null,
        pdvs_unicolor: null,
        add_delete_authorized: null
    }
    const [pdvBlocs, setPdvBlocs] = React.useState<BlocsPdv>({
        pdvBlocNotEmpty: [false, false, false, false, false],
        pdv_blocs: {
            bloc0: initPdvBlocProperties,
            bloc1: initPdvBlocProperties,
            bloc2: initPdvBlocProperties,
            bloc3: initPdvBlocProperties,
            bloc4: initPdvBlocProperties
        }
    })
    const [taux, setTaux] = React.useState<TauxProperties>({
        affichage_taux: {
            affichage_taux_nom: '',
            affichage_taux_formatter_en_pourcent: null,
            affichage_taux_suffix: ''
        }
    })
    const [perimResponsabilite, setPerimResponsabilite] = React.useState<PerimResponsabilite>({
        perim_responsabilite: {
            rang1: '',
            rang2: '',
            rang3: '',
            rang4: '',
            rang5: '',
        }
    })
    const [dataPdv, setDataPdv] = React.useState<string>('')
    const initDisplayPropertiesExceptRg5: Products = {
        prod1: true,
        prod2: true,
        prod3: true,
        prod4: true,
        prod5: true,
        prod6: true,
        prod7: true,
        prod8: true,
        prod9: true,
        prod10: true
    }
    const initDisplayPropertiesRg5: Products = {
        prod1: false,
        prod2: false,
        prod3: false,
        prod4: false,
        prod5: false,
        prod6: false,
        prod7: false,
        prod8: false,
        prod9: false,
        prod10: false
    }
    const initDisplayProperties: Products = {
        prod1: undefined,
        prod2: undefined,
        prod3: undefined,
        prod4: undefined,
        prod5: undefined,
        prod6: undefined,
        prod7: undefined,
        prod8: undefined,
        prod9: undefined,
        prod10: undefined
    }
    const newAccess: boolean = window.location.href.indexOf("/new") > -1
    const checkboxesValue: boolean | undefined = newAccess ? true : undefined
    const [displayProperties, setDisplayProperties] = React.useState<DisplayProperties>({
        affichage: {
            pot_total_tbc: undefined,
            affichage_pots_accessibles: checkboxesValue,
            affichage_pots_exploites: checkboxesValue,
            affichage_pistes: checkboxesValue,
            affichage_pistes_rg5_popup_map: undefined,
            affichage_gains_rg5_popup_map: undefined,
            affichage_pdm_rg5_popup_map: undefined,
            affichage_ventes_rg5_popup_map: undefined,
            affichage_gains: checkboxesValue,
            affichage_pdm: checkboxesValue,
            affichage_ventes: checkboxesValue,
            affichage_products: {
                pdm_product: initDisplayProperties,
                gain_product: initDisplayProperties,
                resume_left: initDisplayProperties,
                tbc_data: initDisplayProperties,
                showPotRg5: initDisplayPropertiesRg5,
                showPotRg4: initDisplayPropertiesExceptRg5,
                showPotRg3: initDisplayPropertiesExceptRg5,
                showPotRg2: initDisplayPropertiesExceptRg5,
                showPotRg1: initDisplayPropertiesExceptRg5,
                showCaRg5: initDisplayPropertiesRg5,
                showCaRg4: initDisplayPropertiesExceptRg5,
                showCaRg3: initDisplayPropertiesExceptRg5,
                showCaRg2: initDisplayPropertiesExceptRg5,
                showCaRg1: initDisplayPropertiesExceptRg5
            }
        }
    })
    const initGroupObj: GroupObjProperties = {
        groupname: '',
        chp1: '',
        chp2: '',
        chp3: '',
        chp4: '',
        chp5: '',
        chp6: '',
        chp7: '',
        chp8: '',
        chp9: '',
        chp10: '',
    }
    const [groupsObj, setGroupsObj] = React.useState<GroupsObj>({
        groupObjNotEmpty: [false, false, false, false, false],
        show_obj: null,
        obj_json: {
            groupobj1: initGroupObj,
            groupobj2: initGroupObj,
            groupobj3: initGroupObj,
            groupobj4: initGroupObj,
            groupobj5: initGroupObj,
        }
    })
    const initQualification: QualificationProperties = {
        nom: '',
        legende: '',
        color: ''
    }
    const [qualifications, setQualifications] = React.useState<Qualifications>({
        qualificationNotEmpty: [false, false, false, false],
        qualification_json: {
            qualif1: initQualification,
            qualif2: initQualification,
            qualif3: initQualification,
            qualif4: initQualification,
        }
    })

    function stringToBoolean(booleanValue: string) {
        if (booleanValue === 'true') {
            return true
        } else if (booleanValue === 'false') {
            return false
        } else {
            return undefined
        }
    }

    function removeUndefinedOrNull(obj: any) {
        for (const key in obj) {
            if (obj[key] === undefined || obj[key] === null) {
                delete obj[key];
            }
        }
    }

    function handleConquestSoftAccessChange() {
        const accessDataObject = mergeAccessDataObjects()
        const urlRequest = isNew
            ? `/organisations/${orgaId}/conquest/softwaresaccesses`
            : `/organisations/${orgaId}/conquest/softwaresaccesses/${softaccessId}`
        $.ajax({
            type: 'POST',
            url: urlRequest,
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(accessDataObject),
            success: function (response: { ok?: boolean }) {
                if (response?.ok === false) {
                    alert("La mise à jour n'a pas pu s'effectuer")
                    return
                }
                onSaved()
            },
            error: function (status: any, error: any) {
                console.log("ERROR", status, error)
                alert("La mise à jour n'a pas pu s'effectuée")
            }
        })
    }

    function mergeAccessDataObjects() {
        const affichageProperties = {
            affichage: {
                ...mainProperties.affichage,
                ...displayProperties.affichage
            }
        }
        /* Empty objects if the switch button was unchecked */
        const fiveIds = ['1', '2', '3', '4', '5']
        let newSecondaryNetworks = { ...secondaryNetworks.secondary_networks }
        fiveIds.map((idNetwork: string, index: number) => {
            if (!secondaryNetworks.secondaryNetworkNotEmpty[index]) {
                newSecondaryNetworks = {
                    ...newSecondaryNetworks,
                    [`secondarynetwork${idNetwork}_file_id`]: '',
                    [`secondarynetwork${idNetwork}_name`]: '',
                    [`secondarynetwork${idNetwork}_potentiel_combinable`]: null,
                    [`secondarynetwork${idNetwork}_map_combinable`]: null
                }
            }
        })
        let newGroupsObj = { ...groupsObj.obj_json }
        fiveIds.map((idGroupObj: string, index: number) => {
            if (!groupsObj.groupObjNotEmpty[index]) {
                newGroupsObj = {
                    ...newGroupsObj,
                    [`groupobj${idGroupObj}`]: {}
                }
            }
        })
        const fourIds = ['1', '2', '3', '4']
        let newQualifications = { ...qualifications.qualification_json }
        fourIds.map((idQualification: string, index: number) => {
            if (!qualifications.qualificationNotEmpty[index]) {
                newQualifications = {
                    ...newQualifications,
                    [`qualif${idQualification}`]: {
                        color: ""
                    }
                }
            }
        })
        let newBlocsPdv: Partial<BlocsPdv['pdv_blocs']> = {}
        const pdvBlocIds = ['0', '1', '2', '3', '4'] as const
        pdvBlocIds.map((idPdvBloc, index: number) => {
            if (pdvBlocs.pdvBlocNotEmpty[index]) {
                const blocKey = `bloc${idPdvBloc}` as keyof BlocsPdv['pdv_blocs']
                newBlocsPdv = {
                    ...newBlocsPdv,
                    [blocKey]: {
                        ...pdvBlocs.pdv_blocs[blocKey]
                    }
                }
                removeUndefinedOrNull(newBlocsPdv[blocKey])
            }
        })
        /* Update collaborators access if secondary network deleted */
        let newCollaboratorsAccesses = [...collaboratorsAccesses]
        if (secondaryNetworks.secondaryNetworkNotEmpty.every((value: boolean) => value === false)) {
            newCollaboratorsAccesses.map((collaborator: CollAccess) => {
                delete collaborator.val_animation_secondary_networks
                delete collaborator.val_developpement_secondary_networks
            })
        }
        const finalAccessDataObject = {
            file_iris_id: mainProperties.file_iris_id,
            file_pdv_id: mainProperties.file_pdv_id,
            name: mainProperties.name,
            mainnetwork_name: mainProperties.mainnetwork_name,
            link: mainProperties.link,
            unit: mainProperties.unit,
            obj_json: { ...newGroupsObj },
            show_obj: groupsObj.show_obj,
            qualification_json: { ...newQualifications },
            ...perimResponsabilite,
            colls_anim_dev_access: JSON.stringify(collaboratorsAccesses),
            ...affichageProperties,
            ...taux,
            data_pdv: dataPdv,
            pdv_blocs: { ...newBlocsPdv },
            secondary_networks: newSecondaryNetworks
        }

        return finalAccessDataObject
    }

    React.useEffect(() => {
        setFilesIrisState(filesIris)
        setFilesPdvState(filesPdv)
        setCollsValues(collaborators)
        setMyForm(initialMyForm)
        if (initialAccesses) {
            setCollaboratorsAccesses(initialAccesses)
        } else {
            setCollaboratorsAccesses(
                collaborators.map((collaborator: CollParameters) => ({
                    coll_id: collaborator.coll_id,
                    val_animation: false,
                    val_developpement: false,
                    val_developpement_modif: false,
                    val_animation_secondary_networks: undefined,
                    val_developpement_secondary_networks: undefined,
                    val_developpement_secondary_networks_modif: undefined,
                })),
            )
        }
    }, [collaborators, filesIris, filesPdv, initialAccesses, initialMyForm])

    React.useEffect(() => {
        if (myForm !== undefined) {
            setMainProperties({
                file_iris_id: myForm.file_iris_id || filesIrisState[0]?.[0] || '',
                file_pdv_id: myForm.file_pdv_id || filesPdvState[0]?.[0] || '',
                name: myForm.name ?? '',
                mainnetwork_name: myForm.mainnetwork_name ?? '',
                link: myForm.link ?? '',
                unit: myForm.unit ?? '',
                affichage: {
                    nom_potentiel: myForm["affichage.nom_potentiel"] ?? '',
                    nom_potentiel_accessible: myForm["affichage.nom_potentiel_accessible"] ?? '',
                    nom_vente: myForm["affichage.nom_vente"] ?? ''
                }
            })
            /* Secondary networks properties */
            const newNetworkNotEmptyValues: boolean[] = []
            {
                ['1', '2', '3', '4', '5'].map((idNetwork: string, index: number) => {
                    newNetworkNotEmptyValues[index] = myForm[`secondary_networks.secondarynetwork${idNetwork}_file_id`] !== undefined
                        && myForm[`secondary_networks.secondarynetwork${idNetwork}_file_id`] !== ''
                })
            }
            setSecondaryNetworks({
                secondaryNetworkNotEmpty: newNetworkNotEmptyValues,
                secondary_networks: {
                    secondarynetwork1_file_id: myForm["secondary_networks.secondarynetwork1_file_id"],
                    secondarynetwork1_name: myForm["secondary_networks.secondarynetwork1_name"] ?? 'Réseau secondaire 1',
                    secondarynetwork1_potentiel_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork1_potentiel_combinable"]) ?? true,
                    secondarynetwork1_map_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork1_map_combinable"]) ?? true,
                    secondarynetwork2_file_id: myForm["secondary_networks.secondarynetwork2_file_id"],
                    secondarynetwork2_name: myForm["secondary_networks.secondarynetwork2_name"] ?? 'Réseau secondaire 2',
                    secondarynetwork2_potentiel_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork2_potentiel_combinable"]) ?? true,
                    secondarynetwork2_map_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork2_map_combinable"]) ?? true,
                    secondarynetwork3_file_id: myForm["secondary_networks.secondarynetwork3_file_id"],
                    secondarynetwork3_name: myForm["secondary_networks.secondarynetwork3_name"] ?? 'Réseau secondaire 3',
                    secondarynetwork3_potentiel_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork3_potentiel_combinable"]) ?? true,
                    secondarynetwork3_map_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork3_map_combinable"]) ?? true,
                    secondarynetwork4_file_id: myForm["secondary_networks.secondarynetwork4_file_id"],
                    secondarynetwork4_name: myForm["secondary_networks.secondarynetwork4_name"] ?? 'Réseau secondaire 4',
                    secondarynetwork4_potentiel_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork4_potentiel_combinable"]) ?? true,
                    secondarynetwork4_map_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork4_map_combinable"]) ?? true,
                    secondarynetwork5_file_id: myForm["secondary_networks.secondarynetwork5_file_id"],
                    secondarynetwork5_name: myForm["secondary_networks.secondarynetwork5_name"] ?? 'Réseau secondaire 5',
                    secondarynetwork5_potentiel_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork5_potentiel_combinable"]) ?? true,
                    secondarynetwork5_map_combinable: stringToBoolean(myForm["secondary_networks.secondarynetwork5_map_combinable"]) ?? true,
                }
            })
            setExistingNetworks({
                network1: newNetworkNotEmptyValues[0],
                network2: newNetworkNotEmptyValues[1],
                network3: newNetworkNotEmptyValues[2],
                network4: newNetworkNotEmptyValues[3],
                network5: newNetworkNotEmptyValues[4],
            })
            /* PDV Blocs properties */
            let newBlocsPdv: BlocsPdv = { ...pdvBlocs }
            {
                ['0', '1', '2', '3', '4'].map((idBlockPdv: string, index: number) => {
                    const newPdvBlocNotEmpty = [...newBlocsPdv.pdvBlocNotEmpty]
                    newPdvBlocNotEmpty[index] = (myForm[`pdv_blocs.bloc${idBlockPdv}.name`] !== ''
                        && myForm[`pdv_blocs.bloc${idBlockPdv}.name`] !== undefined) || (myForm[`pdv_blocs.bloc${idBlockPdv}.file_id`] !== ''
                            && myForm[`pdv_blocs.bloc${idBlockPdv}.file_id`] !== undefined)
                    newBlocsPdv = {
                        ...newBlocsPdv,
                        pdvBlocNotEmpty: newPdvBlocNotEmpty,
                        pdv_blocs: {
                            ...newBlocsPdv.pdv_blocs,
                            [`bloc${idBlockPdv}`]: {
                                file_id: myForm[`pdv_blocs.bloc${idBlockPdv}.file_id`],
                                name: myForm[`pdv_blocs.bloc${idBlockPdv}.name`],
                                display_btn: stringToBoolean(myForm[`pdv_blocs.bloc${idBlockPdv}.display_btn`]) ?? null,
                                display_gmap_url: stringToBoolean(myForm[`pdv_blocs.bloc${idBlockPdv}.display_gmap_url`]) ?? null,
                                excel_export: stringToBoolean(myForm[`pdv_blocs.bloc${idBlockPdv}.excel_export`]) ?? null,
                                pdvs_unicolor: stringToBoolean(myForm[`pdv_blocs.bloc${idBlockPdv}.pdvs_unicolor`]) ?? null,
                                add_delete_authorized: stringToBoolean(myForm[`pdv_blocs.bloc${idBlockPdv}.add_delete_authorized`]) ?? null
                            }
                        }
                    }
                })
            }
            setPdvBlocs(newBlocsPdv)
            /* Taux properties */
            setTaux({
                affichage_taux: {
                    affichage_taux_nom: myForm["affichage_taux.affichage_taux_nom"] ?? '',
                    affichage_taux_formatter_en_pourcent: stringToBoolean(myForm["affichage_taux.affichage_taux_formatter_en_pourcent"]) ?? null,
                    affichage_taux_suffix: myForm["affichage_taux.affichage_taux_suffix"] ?? ''
                }
            })
            /* Perim responsabilities properties */
            setPerimResponsabilite({
                perim_responsabilite: {
                    rang1: myForm["perim_responsabilite.rang1"] ?? '',
                    rang2: myForm["perim_responsabilite.rang2"] ?? '',
                    rang3: myForm["perim_responsabilite.rang3"] ?? '',
                    rang4: myForm["perim_responsabilite.rang4"] ?? '',
                    rang5: myForm["perim_responsabilite.rang5"] ?? '',
                }
            })
            /* Data for pdv custom */
            setDataPdv(myForm["data_pdv"])
            /* Display properties (products, potentiel, pdm, piste, gain) */
            let newDisplayProperties: DisplayProperties = {
                ...displayProperties,
                affichage: {
                    affichage_pots_accessibles: stringToBoolean(myForm["affichage.affichage_pots_accessibles"]) ?? displayProperties.affichage.affichage_pots_accessibles,
                    affichage_pots_exploites: stringToBoolean(myForm["affichage.affichage_pots_exploites"]) ?? displayProperties.affichage.affichage_pots_exploites,
                    affichage_pistes: stringToBoolean(myForm["affichage.affichage_pistes"]) ?? displayProperties.affichage.affichage_pistes,
                    affichage_gains: stringToBoolean(myForm["affichage.affichage_gains"]) ?? displayProperties.affichage.affichage_gains,
                    affichage_pdm: stringToBoolean(myForm["affichage.affichage_pdm"]) ?? displayProperties.affichage.affichage_pdm,
                    affichage_ventes: stringToBoolean(myForm["affichage.affichage_ventes"]) ?? displayProperties.affichage.affichage_ventes,
                    affichage_pistes_rg5_popup_map: stringToBoolean(myForm["affichage.affichage_pistes_rg5_popup_map"]),
                    affichage_gains_rg5_popup_map: stringToBoolean(myForm["affichage.affichage_gains_rg5_popup_map"]),
                    affichage_pdm_rg5_popup_map: stringToBoolean(myForm["affichage.affichage_pdm_rg5_popup_map"]),
                    affichage_ventes_rg5_popup_map: stringToBoolean(myForm["affichage.affichage_ventes_rg5_popup_map"]),
                    pot_total_tbc: stringToBoolean(myForm["affichage.pot_total_tbc"]),
                    affichage_products: {
                        ...displayProperties.affichage.affichage_products
                    }
                },
            }
            {
                ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'].map((idProduct: string) => {
                    newDisplayProperties = {
                        ...newDisplayProperties,
                        affichage: {
                            ...newDisplayProperties.affichage,
                            affichage_products: {
                                pdm_product: {
                                    ...newDisplayProperties.affichage.affichage_products.pdm_product,
                                    [`prod${idProduct}`]: stringToBoolean(myForm[`affichage.affichage_products.pdm_product.prod${idProduct}`])
                                },
                                gain_product: {
                                    ...newDisplayProperties.affichage.affichage_products.gain_product,
                                    [`prod${idProduct}`]: stringToBoolean(myForm[`affichage.affichage_products.gain_product.prod${idProduct}`])
                                },
                                resume_left: {
                                    ...newDisplayProperties.affichage.affichage_products.resume_left,
                                    [`prod${idProduct}`]: stringToBoolean(myForm[`affichage.affichage_products.resume_left.prod${idProduct}`])
                                },
                                tbc_data: {
                                    ...newDisplayProperties.affichage.affichage_products.tbc_data,
                                    [`prod${idProduct}`]: stringToBoolean(myForm[`affichage.affichage_products.tbc_data.prod${idProduct}`])
                                },
                                showPotRg5: {
                                    ...newDisplayProperties.affichage.affichage_products.showPotRg5,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showPotRg5.prod${idProduct}`]) : false
                                },
                                showPotRg4: {
                                    ...newDisplayProperties.affichage.affichage_products.showPotRg4,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showPotRg4.prod${idProduct}`]) : true
                                },
                                showPotRg3: {
                                    ...newDisplayProperties.affichage.affichage_products.showPotRg3,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showPotRg3.prod${idProduct}`]) : true
                                },
                                showPotRg2: {
                                    ...newDisplayProperties.affichage.affichage_products.showPotRg2,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showPotRg2.prod${idProduct}`]) : true
                                },
                                showPotRg1: {
                                    ...newDisplayProperties.affichage.affichage_products.showPotRg1,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showPotRg1.prod${idProduct}`]) : true
                                },
                                showCaRg5: {
                                    ...newDisplayProperties.affichage.affichage_products.showCaRg5,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showCaRg5.prod${idProduct}`]) : false
                                },
                                showCaRg4: {
                                    ...newDisplayProperties.affichage.affichage_products.showCaRg4,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showCaRg4.prod${idProduct}`]) : true
                                },
                                showCaRg3: {
                                    ...newDisplayProperties.affichage.affichage_products.showCaRg3,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showCaRg3.prod${idProduct}`]) : true
                                },
                                showCaRg2: {
                                    ...newDisplayProperties.affichage.affichage_products.showCaRg2,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showCaRg2.prod${idProduct}`]) : true
                                },
                                showCaRg1: {
                                    ...newDisplayProperties.affichage.affichage_products.showCaRg1,
                                    [`prod${idProduct}`]: !isNew ? stringToBoolean(myForm[`affichage.affichage_products.showCaRg1.prod${idProduct}`]) : true
                                }
                            }
                        }
                    }
                })
            }
            setDisplayProperties(newDisplayProperties)
            /* Columns objectifs properties */
            let newGroupsObj: GroupsObj = {
                ...groupsObj,
                show_obj: stringToBoolean(myForm["show_obj"]) ?? null
            }
            {
                ['1', '2', '3', '4', '5'].map((idGroup: string, indexGroup: number) => {
                    const groupKey = `groupobj${idGroup}` as keyof GroupsObj['obj_json']
                    const newGroupObjNotEmpty = [...newGroupsObj.groupObjNotEmpty]
                    const groupName = myForm[`obj_json.groupobj${idGroup}.groupname`]
                    newGroupObjNotEmpty[indexGroup] = groupName !== undefined && groupName !== ''
                    newGroupsObj = {
                        ...newGroupsObj,
                        groupObjNotEmpty: newGroupObjNotEmpty,
                        obj_json: {
                            ...newGroupsObj.obj_json,
                            [groupKey]: {
                                ...newGroupsObj.obj_json[groupKey],
                                groupname: groupName
                            }
                        }
                    }
                    {
                        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'].map((idChamp: string, indexChamp: number) => {
                            newGroupsObj = {
                                ...newGroupsObj,
                                obj_json: {
                                    ...newGroupsObj.obj_json,
                                    [groupKey]: {
                                        ...newGroupsObj.obj_json[groupKey],
                                        [`chp${idChamp}`]: myForm[`obj_json.groupobj${idGroup}.chp${idChamp}`]
                                    }
                                }
                            }
                        })
                    }
                })
            }
            setGroupsObj(newGroupsObj)
            /* Qualifications properties */
            let newQualifications: Qualifications = { ...qualifications }
            {
                ['1', '2', '3', '4'].map((idQualification: string, index: number) => {
                    const newQualificationNotEmpty = [...newQualifications.qualificationNotEmpty]
                    const qualificationName = myForm[`qualification_json.qualif${idQualification}.nom`]
                    newQualificationNotEmpty[index] = qualificationName !== undefined && qualificationName !== ''
                    newQualifications = {
                        ...newQualifications,
                        qualificationNotEmpty: newQualificationNotEmpty,
                        qualification_json: {
                            ...newQualifications.qualification_json,
                            [`qualif${idQualification}`]: {
                                nom: qualificationName,
                                legende: myForm[`qualification_json.qualif${idQualification}.legende`],
                                color: myForm[`qualification_json.qualif${idQualification}.color`] ?? ''
                            }
                        }
                    }
                })
            }
            setQualifications(newQualifications)
        }
    }, [myForm])

    const headerStyle = {
        fontSize: '24px',
        fontWeight: '500',
        lineHeight: '24px'
    };

    return (
        <div>
            {myForm !== undefined && (
                <div>
                    <CMainProperties
                        filesIris={filesIrisState}
                        filesPdv={filesPdvState}
                        mainProperties={mainProperties}
                        setMainProperties={setMainProperties}
                    />

                    <Collapse
                        ghost
                        defaultActiveKey={['secondary_networks', 'pdv_blocks', 'display_properties', 'taux', 'columns_obj', 'qualifications', 'perim_responsabilities', 'custom_access', 'custom_pdv']}
                        expandIcon={({ isActive }) => <CustomArrowIcon isActive={isActive ?? false} />}
                    >
                        <Panel
                            header={<CustomHeader text="Réseaux secondaires" style={headerStyle} />}
                            key="secondary_networks"
                        >
                            <CSecondaryNetworks
                                filesIris={filesIrisState}
                                existingNetworks={existingNetworks}
                                setExistingNetworks={setExistingNetworks}
                                secondaryNetworks={secondaryNetworks}
                                setSecondaryNetworks={setSecondaryNetworks}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Blocs Pdv" style={headerStyle} />}
                            key="pdv_blocks"
                        >
                            <CBlocksPdv
                                filesPdv={filesPdvState}
                                pdvBlocs={pdvBlocs}
                                setPdvBlocs={setPdvBlocs}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Affichage des notions suivantes :" style={headerStyle} />}
                            key="display_properties"
                        >
                            <CDisplayProperties
                                isEdit={!isNew}
                                displayProperties={displayProperties}
                                setDisplayProperties={setDisplayProperties}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Affichage données taux (pdm) :" style={headerStyle} />}
                            key="taux"
                        >
                            <CTaux
                                taux={taux}
                                setTaux={setTaux}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Colonnes objectifs" style={headerStyle} />}
                            key="columns_obj"
                        >
                            <CColumnsObj
                                groupsObj={groupsObj}
                                setGroupsObj={setGroupsObj}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Qualifications" style={headerStyle} />}
                            key="qualifications"
                        >
                            <CQualifications
                                qualifications={qualifications}
                                setQualifications={setQualifications}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Périmètre de responsabilité" style={headerStyle} />}
                            key="perim_responsabilities"
                        >
                            <CPerimResponsabilities
                                perimResponsabilite={perimResponsabilite}
                                setPerimResponsabilite={setPerimResponsabilite}
                            />
                        </Panel>
                        <Panel
                            header={<CustomHeader text="Accès animation et expansion" style={headerStyle} />}
                            key="custom_access"
                        >
                            <CCustomAccess
                                collaborators={collsValues}
                                collaboratorsAccesses={collaboratorsAccesses}
                                setCollaboratorsAccesses={setCollaboratorsAccesses}
                                existingNetworks={existingNetworks}
                            />
                        </Panel>
                    </Collapse>
                    <Row style={{ margin: '24px 0' }}>
                        <Col span={2}>
                            <Button onClick={onCancel}>
                                Annuler
                            </Button>
                        </Col>
                        <Col span={2} offset={20}>
                            <Button
                                type="primary"
                                onClick={() => { handleConquestSoftAccessChange() }}
                                style={{ float: 'right' }}
                            >
                                Enregistrer
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    )
}
